import { render, staticRenderFns } from "./qingjia.vue?vue&type=template&id=7349d00a&scoped=true"
import script from "./qingjia.vue?vue&type=script&lang=js"
export * from "./qingjia.vue?vue&type=script&lang=js"
import style0 from "./qingjia.vue?vue&type=style&index=0&id=7349d00a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7349d00a",
  null
  
)

export default component.exports